module.exports = __webpack_public_path__ + "static/media/nandana.3413cd8a.webp";